// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

//urls should be in the format of [protocol]://[fqdn]{:port}{/common path}
//example:
//if the documents API exists at https://eqms-documents.azurewebsites.net/api/documents
//then here the entry would look like: https://eqms-documents.azurewebsites.net/api/

//
//let environmentName = "dev-green";
let prefix = "https://";
let suffix = ".training-t096.eqms.training.gl.eurofinsbpt.com/api/";
 
let documentsApi = prefix + "documents" + suffix;
let delegatesApi = prefix + "delegates" + suffix;
let assignmentGroupsApi = prefix + "assignment-groups" + suffix;
let trainingApi = prefix + "training" + suffix;
let administrationApi = prefix + "administration" + suffix;
let changeManagement = prefix + "changemanagement" + suffix;
let recordKPRApi = prefix  + "recordkpr"  + suffix;
let skillsApi = prefix + "skill" + suffix;

export const environment = {
  production: true,
  urls: {
    apis: {
      documents: documentsApi,
      documentAttachments: documentsApi,
      changeRequests: documentsApi,
      hardCopyActivities: documentsApi,
      // dev green need to change
      dependencies: "https://famsidentity.lims.training.gl.eurofinsbpt.com/Carbon//api/", 
      files: "https://files.training-t096.eqms.training.gl.eurofinsbpt.com/api/",
      delegates: delegatesApi,
      assignmentgroups: assignmentGroupsApi,
      courses: trainingApi,
      boron: "https://app-eqms-elims-boron-t096-usc.azurewebsites.net/api/",
      administration: administrationApi,
      changeControl: changeManagement,
      recordKPR: recordKPRApi,
	  skills: skillsApi
    }
  },
  surveyJsProductKey:"ZDBlYWZjYmMtYTg2Mi00M2ZlLTg4MWUtMWJkMmMwY2ViNjI0OzE9MjAyNC0xMC0xMCwyPTIwMjMtMDItMDc=",
  retryAttempts:3,
  limitedDashboardProfile: false
};